import { ActionIcon, Menu } from "@mantine/core";
import { IconDotsVertical, IconEdit, IconEye, IconTrash } from "@tabler/icons-react";
import EditItemButton from "@/components/edit-item-button";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import { getCurrentUser } from "@/services/auth";
import { ID_LISTAGEM_IDEIAS_IDEIAS } from "@/utils/constants";
import ideiaSchema from "../../schema/ideia-schema";
import PublicarIdeiaButton from "../publicar-ideia-button";
import RemoverIdeiaButton from "../remover-ideia-button";

const PublishIdeia = ({ ideia }: { ideia: TIdeia }) => {
  return (
    <>
      <Menu.Item leftSection={<IconEye size={14} />} component={PublicarIdeiaButton} ideia={ideia}>
        Publicar
      </Menu.Item>
    </>
  );
};

const EditIdeia = ({ ideia }: { ideia: TIdeia }) => {
  return (
    <>
      <Menu.Item
        leftSection={<IconEdit size={14} />}
        component={EditItemButton}
        modal="ideia-form-modal"
        schema={ideiaSchema}
        item={ideia}
      >
        Editar
      </Menu.Item>
    </>
  );
};

const RemoveIdeia = ({ ideia }: { ideia: TIdeia }) => {
  return (
    <>
      <Menu.Divider />
      <Menu.Item color="red" leftSection={<IconTrash size={14} />} component={RemoverIdeiaButton} ideia={ideia}>
        Remover
      </Menu.Item>
    </>
  );
};

// prettier-ignore
const ContextMenuRow = ({ ideia }: { ideia: TIdeia }) => {
  const uid = getCurrentUser()?.uid;

  const { create, update, remove } = useGetAuthorizations(ID_LISTAGEM_IDEIAS_IDEIAS);

  const isAuthor = ideia.createdBy === uid;
  const isIdeaPublished = !!ideia.publishedAt;

  const canRemoveIdeia = remove || (create && isAuthor && !isIdeaPublished);
  const canEditIdeia = update || (create && isAuthor && !isIdeaPublished);
  const canPublishIdeia = !isIdeaPublished && (update || (create && isAuthor));

  if (!canRemoveIdeia && !canEditIdeia && !canPublishIdeia) {
    return <></>
  }

  return (
    <Menu shadow="md" width={200} position="left" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon variant="transparent" aria-label="Menu" color="gray">
          <IconDotsVertical />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {canPublishIdeia && <PublishIdeia ideia={ideia} />}
        {canEditIdeia && <EditIdeia ideia={ideia} />}
        {canRemoveIdeia && <RemoveIdeia ideia={ideia} />}
      </Menu.Dropdown>
    </Menu>
  );
};

export default ContextMenuRow;
